<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="formRoleTypeInfo" ref="formRoleTypeInfo" class="demo-form-inline" :rules="rules">
                <el-row :gutter="20">
                    <el-col>
                        <td-permission :permissions="permissionsView">
                            <div slot="havePermission">
                                <!--角色类型名称 -->
                                <el-form-item :label="$t('role.ROLES_TYPE_NAME')">
                                    <td-input v-model="formRoleTypeInfo.sName" maxlength="30" :placeholder="defaultInputText" special-character-check="true"></td-input>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item>
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click.native="btnQuery()">{{ $t('common.QUERY') }}</td-button>
                            <td-button type="button" :permissions="permissionsAdd" @click.native="btnAdd">{{ $t('common.ADD') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                ref="taTable"
                :dataSource="tableData"
                :hasIndex="false"
                :permissions="permissionsView"
                :columns="columns"
                :hasLoading="loading"
                :pageSize="formRoleTypeInfo.pageSize"
                :pageNum="formRoleTypeInfo.pageNum"
                :total="total"
                :rowKey="tableKey"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
        </el-main>
        <!-- 加载dialog -->
        <dialog-CustomRole
            v-if="dialogCustomRoleVisible"
            :isEdit="isEdit"
            :isShowSave="isShowSave"
            :editData="editData"
            :dialogCustomRoleVisible="dialogCustomRoleVisible"
            :title="title"
            ref="addOrModifyInfo"
            @handleSizeChange="handleSizeChange"
            @customRoleDialogClose="customRoleDialogClose"
            @onSuccess="onSuccess"
        ></dialog-CustomRole>
    </el-container>
</template>

<script>
import customRole from './assets/api.js';
import dialogCutomRole from './components/dialogCutomRole.vue';
export default {
    components: {
        'dialog-CustomRole': dialogCutomRole
    },
    props: {},
    data() {
        return {
            permissionsAdd: ['role:add'],
            permissionsEdit: ['role:edit'],
            permissionsView: ['role:view'],
            permissionsDel: ['role:del'],
            isEdit: false,
            isShowSave: true,
            editData: '',
            btnLoading: false,
            tableData: [],
            deviceTypeList: [],
            loading: false,
            total: 0,
            tableKey: 'sId',
            title: this.$t('customRoleType.ADD_CUSTOM_ROLE_TYPE'),
            dialogCustomRoleVisible: false,
            formRoleTypeInfo: {
                sName: '',
                pageSize: 50,
                pageNum: 1
            },
            columns: [
                {
                    label: this.$t('customRoleType.ROLE_TYPE_NUM'),
                    prop: 'iTypeId',
                    align: 'center',
                    minWidth: '110',
                    showOverflowTooltip: true
                },
                {
                    label: this.$t('customRoleType.ROLE_TYPE'),
                    prop: 'sName',
                    align: 'center',
                    minWidth: '110',
                    showOverflowTooltip: true
                },
                {
                    label: this.$t('customRoleType.DESCRIPTION'),
                    prop: 'sDescription',
                    align: 'center',
                    minWidth: '110',
                    showOverflowTooltip: true
                },
                {
                    label: 'common.OPERATE',
                    minWidth: '120',
                    align: 'center',
                    render: (createElement, params) => {
                        let editBtn = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissionsEdit },
                                on: {
                                    click: () => {
                                        this.btnEdit(params.row);
                                    }
                                }
                            },
                            this.$t('common.EDIT')
                        );
                        let delBtn = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissionsDel },
                                on: {
                                    click: () => {
                                        this.btnDel(params.row);
                                    }
                                }
                            },
                            this.$t('common.DELETE')
                        );
                        let viewBtn = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissionsView },
                                on: {
                                    click: () => {
                                        this.btnView(params.row);
                                    }
                                }
                            },
                            this.$t('customRoleType.VIEW')
                        );
                        let operateList = [];
                        if (
                            params.row.iTypeId == window.authCommon.roleType.ordinaryRole ||
                            params.row.iTypeId == window.authCommon.roleType.orgRole ||
                            params.row.iTypeId == window.authCommon.roleType.doorAuthGroup
                        ) {
                            operateList = [viewBtn];
                        } else {
                            operateList = [editBtn, delBtn];
                        }
                        return createElement('div', operateList);
                    }
                }
            ]
        };
    },
    created() {
        this.queryData();
    },
    methods: {
        //dialog回调方法
        onSuccess() {
            this.queryData();
        },
        btnQuery() {
            this.formRoleTypeInfo.pageNum = 1;
            this.queryData();
        },
        btnAdd() {
            this.isEdit = false;
            this.isShowSave = true;
            this.dialogCustomRoleVisible = true;
        },
        btnEdit(row) {
            this.isEdit = true;
            this.isShowSave = true;
            this.editData = row;
            this.dialogCustomRoleVisible = true;
        },
        btnView(row) {
            this.isShowSave = false;
            this.editData = row;
            this.dialogCustomRoleVisible = true;
        },
        btnDel(row) {
            let formData = new FormData();
            formData.append('id', row.sId);
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    customRole.delRoleTypeInfo(formData, response => {
                        if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('/roleType/delRoleTypeInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.queryData();
                    });
                })
                .catch(() => {});
        },
        /* 当前页变化事件 */
        currentChange(val) {
            this.formRoleTypeInfo.pageNum = val;
            this.queryData();
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.formRoleTypeInfo.pageSize = pageSize;
            this.btnQuery();
        },
        queryData() {
            this.loading = true;
            let params = this.formRoleTypeInfo;
            customRole.queryRoleTypeInfo(JSON.stringify(params), response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$log.error('/roleType/queryRoleTypeInfo', params, response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.total = response.data.count;
                this.tableData = response.data.content;
                this.loading = false;
            });
        },
        //关闭dialog
        customRoleDialogClose() {
            this.dialogCustomRoleVisible = false;
        }
    }
};
</script>
<style></style>
